import { MetaData } from "@/domains/common/layout/metadata"
import { PageContainer } from "@/domains/common/layout/page-container"
import { PageTitle } from "@/domains/common/layout/page-title"
import { DesignSubItem } from "@/domains/navigation/subitems/design-subitem"
import { DesignUiSystemSubItem } from "@/domains/navigation/subitems/design-ui-system-subitem"

export const DESIGN_BREADCRUMB_ITEMS = [new DesignSubItem(), new DesignUiSystemSubItem()]

const DesignUISystemPage = () => {
  return (
    <PageContainer>
      <MetaData title="Design | Design System" />
      <PageTitle title="UI System" subTitle="Our UI system and components" items={DESIGN_BREADCRUMB_ITEMS} />

      <div></div>
    </PageContainer>
  )
}

export default DesignUISystemPage
